import { RadioGroup, FormControlLabel, Radio, TextField } from '@mui/material'
import React, { useState } from 'react'

function DemoStep5() {

  const [selectedOption, setSelectedOption] = useState("1");

  return (
    <>
      <div className="form">
        <div className="gap_p">
          <div className="control_group w_100">
            <h3 className='hd_6'>Upload Product Video/Short Reel (Optional)</h3>

            {/* Radio options */}
            
          </div>

          <div className="control_group w_100">
            {/* Conditionally render input fields */}
            

          
              <div className="upload_box" style={{ marginTop: "8px" }}>
                <label className="upload_action">
                  <input type="file" accept="video/*" />
                  <p>
                  <img src="/static/images/upload_icon.svg" alt='icon' />
                    <strong>Click to upload a short reel or drag and drop</strong>
                  </p>
                </label>
              </div>
         
          </div>
        </div>
      </div>
    </>
  )
}

export default DemoStep5